import { process } from "@progress/kendo-data-query";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import QualificationForm from "./QualificationForm";
import {
  deleteQualificationFromTable,
  addQualificationRecord,
} from "./qualificationService";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import * as XLSX from "xlsx";
import $ from "jquery";

import "./QualificationTable.scss";
import {
  getValueFromText,
  getpreQualText,
  getDdRegionDataQualification,
  checkValue,
  checkText,
  buildAddPreQualArray,
} from "./QualificationTableService";
import { getDdRegionData } from "../CarrierMaster/CarrierContact/CarrierContactService";
import ExcelErrorRecords from "./ExcelErrorRecords";

function QualificationTable({ tableData, onSearchClick, ddData, userData, lastSearchState }) {
  const [dataState, setDataState] = useState({
    skip: 0,
    take: 10,
  });
  const [result, setResult] = useState(
    process(
      tableData.map((dataItem) => Object.assign({ selected: false }, dataItem)),
      dataState
    )
  );
  const [visibleDialog, setVisibleDialog] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  let _export = useRef(null);
  const _geo = useRef([]);
  const _zoneJson = useRef([]);
  const _completecountry = useRef([]);
  const duplicateRecordDisplay = useRef([]);
  // , setDuplicateRecordDisplay]
  const [OJS, setOJS] = useState(null);
  const [duplicateVisiable, setDuplicateVisiable] = useState(false);
  const { ROLE_LIST } = JSON.parse(sessionStorage.getItem("profile"));
  const { MDADMIN, MDVIEWER } = ROLE_LIST;

  useEffect(() => {
    console.log(ddData);

      document.getElementById("buttonid").addEventListener("click", openDialog);
    
    async function getGeo() {
      _geo.current = [...(await getDdRegionDataQualification())].map(
        (data) => ({ value: data["value"], text: data["geo"] })
      );
      _zoneJson.current = ddData["originDestination"].map((data) => ({
        country: data["country"].split("-")[0],
        geo: data["geo"],
        text: data["port"].split("-")[1],
        value: data["port"],
      }));
      _completecountry.current = ddData["originDestination"].map((data) => ({
        geo: data["geo"],
        text: `${data["country"].split("-")[1]}-${
          data["country"].split("-")[0]
        }`,
        value: data["country"].split("-")[0],
      }));
    }
    getGeo();
    function openDialog() {
      document.getElementById("fileid").click();
    }
  }, []);

  useEffect(() => {
    setResult(
      process(
        tableData.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        ),
        dataState
      )
    );
  }, [tableData]);

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem({ ...item, type: "edit" });
  };

  const addRecord = () => {
    const item = {
      type: "add",
    };
    console.log({ item });
    setOpenForm(true);
    setEditItem(item);
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  let checkOriginGeoPort = (formValues) => {
    let passORFail = false;
    let orignData;
    let DestinationData;
    
    orignData = ddData['originDestination'].find(data => data['port'] === formValues.originValue.text)
    DestinationData = ddData['originDestination'].find(data => data['port'] === formValues.destinationValue.text)
    
    if(orignData.geo != formValues.originGeo.text || orignData.port != formValues.originValue.text || orignData.country != formValues.originCountry.text)
    {
      toast.error("Origin(geo,port,country) values having Incorrect combination");
      passORFail = true;
    }
    
    if(DestinationData.geo != formValues.destinationGeo.text || DestinationData.port != formValues.destinationValue.text || DestinationData.country != formValues.destCountry.text){
      toast.error("Destination(geo,port,country) values having Incorrect combination");
      passORFail = true;
    }
        
    return passORFail;
  }

  const handleSubmit = async (formValues) => {
    let checkReturn = false;
    const {
      carrier,
      mode,
      originValue,
      destinationValue,
      servType,
      qualified,
      originGeo,
      originCountry,
      destinationGeo,
      destCountry,
      serviceLevel,
      primaryOwner,
      allocatIndicator,
    } = formValues;

    if (qualified === "" || qualified == undefined) {
      toast.error("Please select qualified value");
      checkReturn = true;
    }
    if (originGeo === "" || originGeo == undefined) {
      toast.error("Please select Origin Geo");
      checkReturn = true;
    }
    if (originValue === "" || originValue == undefined) {
      toast.error("Please select Origin Port");
      checkReturn = true;
    }
    if (originCountry === "" || originCountry == undefined) {
      toast.error("Please select Origin Country");
      checkReturn = true;
    }
    if (destinationGeo === "" || destinationGeo == undefined) {
      toast.error("Please select Destination Geo");
      checkReturn = true;
    }
    if (destCountry === "" || destCountry == undefined) {
      toast.error("Please select Destination Country");
      checkReturn = true;
    }
    if (destinationValue === "" || destinationValue == undefined) {
      toast.error("Please select Destination Port");
      checkReturn = true;
    }
    if (servType === "" || servType == undefined) {
      toast.error("Please select Service Type");
      checkReturn = true;
    }
    if (mode === "" || mode == undefined) {
      toast.error("Please select Mode Value");
      checkReturn = true;
    }
    if (carrier === "" || carrier == undefined) {
      toast.error("Please select Carrier");
      checkReturn = true;
    }
    if (serviceLevel === "" || serviceLevel == undefined) {
      toast.error("Please select service level");
      checkReturn = true;
    }
    if (primaryOwner === "" || primaryOwner == undefined) {
      toast.error("Please select primary owner");
      checkReturn = true;
    }
    if (allocatIndicator === "" || allocatIndicator == undefined) {
      toast.error("Please select allocation indicator");
      checkReturn = true;
    }
    if(!checkReturn && checkOriginGeoPort(formValues)) {
        checkReturn = true;
    }
    if (checkReturn) {
      return;
    }

    setOpenForm(false);
    // return;

    const payloadData = {
      dataList: [
        {
          carrier: formValues["carrier"]["value"].split("-")[0],
          scacd: formValues["carrier"]["text"],
          originGeo: formValues["originGeo"]["value"],
          originValue: formValues["originValue"]["value"],
          destinationGeo: formValues["destinationGeo"]["value"],
          destinationValue: formValues["destinationValue"]["value"],
          originType: formValues["originType"],
          destinationType: formValues["destinationType"],
          modeOfTransport: formValues["mode"]["value"],
          servType: formValues["servType"]["value"],
          qualified: formValues["qualified"],
          remarks: formValues["remarks"] ? formValues["remarks"] : '',
          originCountry: formValues["originCountry"]["value"],
          destCountry: formValues["destCountry"]["value"],
          serviceLevel: formValues["serviceLevel"]["value"],
          primaryOwner: formValues["primaryOwner"]["text"],
          secondaryOwner: formValues["secondaryOwner"] && formValues["secondaryOwner"]["text"] ? formValues["secondaryOwner"]["text"] : '',
          allocatIndicator: formValues["allocatIndicator"],
        },
      ],
    };

    if (formValues["isEditForm"]) {
      payloadData["action"] = "EDIT";
      payloadData["dataList"][0]["changedBy"] = userData["USER_ID"];
      payloadData["dataList"][0]["id"] = formValues["id"];
      payloadData["dataList"][0]["validFrom"] = formValues["validFrom"];
      payloadData["dataList"][0]["validTo"] = formValues["validTo"];
    } else {
      payloadData["action"] = "SUBM";
      payloadData["dataList"][0]["createdBy"] = userData["USER_ID"];
      payloadData["dataList"][0]["id"] = "";
      payloadData["dataList"][0]["validFrom"] = new Date();
      payloadData["dataList"][0]["validTo"] = "99991231";
    }

    const response = await addQualificationRecord(payloadData);

    if (!formValues["isEditForm"]) {
      onQualificationSuccessful(response);
    } else {
      if (response[0]["msgStatus"] === "S") {
        toast.success("Record Inserted / Updated successfully");
        onSearchClick(lastSearchState);
        setDataState({ skip: 0, take: 10 });
      } else {
        toast.error(response[0].msg);
      }
    }
  };

  function onQualificationSuccessful(response) {
    if (response.length === 0) {
      toast.success("Record Inserted / Updated successfully");
      onSearchClick(lastSearchState);
      setDataState({ skip: 0, take: 10 });
    } else if (response[0].msgStatus === "E") {
      toast.error(response[0].msg);
    }
  }

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  const selectionChange = (event) => {
    const data = result.data.map((item) => {
      if (item.id === event.dataItem.id) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    setResult({ ...result, data });
  };

  const onDataStateChange = (event) => {
    setDataState(event.dataState);
    setResult(
      process(
        tableData.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        ),
        event.dataState
      )
    );
  };

  const headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = result.data.map((item) => {
      item.selected = checked;
      return item;
    });
    setResult({ ...result, data });
  };

  const toggleDialog = (props) => {
    if (
      result["data"].findIndex((dataItem) => dataItem["selected"] === true) ===
      -1
    ) {
      toast.error("Nothing to delete");
      return;
    }
    setVisibleDialog(!visibleDialog);
  };

  const deleteRow = async () => {
    setVisibleDialog(!visibleDialog);
    const itemDeleteRow = result["data"].filter(
      (dataItem) => dataItem["selected"] === true
    );
    itemDeleteRow["scac"] = itemDeleteRow["scacd"];
    const response = await deleteQualificationFromTable({
      action: "DELE",
      dataList: itemDeleteRow,
    });
    response.forEach((res, i, arr) => {
      if (res["msg"] === "Success") {
        toast.success(
          `Carrier with scac id ${res["scacd"]} Deleted Successfully`
        );
      } else {
        toast.error(`Error While Deleting Carrier ${res["carrier"]}`);
      }
    });

    onSearchClick(lastSearchState);
    setDataState({ skip: 0, take: 10 });
  };

  const exportExcel = () => {
    _export.save(tableData);
    toast.success(`Exporting ${tableData.length} records ...`,{autoClose: 40000});
  };

  const getFileName = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = dd + "/" + mm + "/" + yyyy;
    return `Qualification_${today}`;
  };

  const fileName = getFileName();

  const updloadExcel = (oEvent) => {
    duplicateRecordDisplay.current = [];

    // Get The File From The Input
    var oFile = oEvent.target.files[0];

    // Create A File Reader HTML5
    var reader = new FileReader();

    // Ready The Event For When A File Gets Selected
    reader.onload = (e) => {
      var data = e.target.result;
      //IE Issue with Upload
       var cfb = XLSX.read(data, { type: "array" }); 

    

      cfb["SheetNames"].forEach(async (key, value) => {
        // Obtain The Current Row As CSV
        let excelHeadersValid = true;
        // var key1 = key;
        // var val = value;
        //  var sCSV = XLSX.utils.make_csv(cfb.Sheets[key]); 
        let oJS = XLSX.utils.sheet_to_json(cfb.Sheets[key]); 

        if (oJS.length) {
          let newOJSArray = [];
          let errorHeaderNames = [];
          oJS.map((eachRow) => {
            errorHeaderNames = [];
            console.log("eachRow", eachRow);
            let _tempObj = {};
            if ("SCAC" in eachRow) {
              _tempObj.scacd = eachRow["SCAC"];
            } else {
              errorHeaderNames.push("SCAC");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Mode" in eachRow) {
              _tempObj.modeOfTransport = eachRow["Mode"];
            } else {
              errorHeaderNames.push("Mode");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Origin Port" in eachRow) {
              _tempObj.originValue = eachRow["Origin Port"];
            } else {
              errorHeaderNames.push("Origin Port");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Origin Country / Region" in eachRow) {
              _tempObj.originCountry = eachRow["Origin Country / Region"];
            } else {
              errorHeaderNames.push("Origin Country / Region");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Origin Geo" in eachRow) {
              _tempObj.originGeo = eachRow["Origin Geo"];
            } else {
              errorHeaderNames.push("Origin Geo");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Destination Port" in eachRow) {
              _tempObj.destinationValue = eachRow["Destination Port"];
            } else {
              errorHeaderNames.push("Destination Port");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Destination Country / Region" in eachRow) {
              _tempObj.destCountry = eachRow["Destination Country / Region"];
            } else {
              errorHeaderNames.push("Destination Country / Region");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Destination Geo" in eachRow) {
              _tempObj.destinationGeo = eachRow["Destination Geo"];
            } else {
              errorHeaderNames.push("Destination Geo");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Commodity" in eachRow) {
              _tempObj.servType = eachRow["Commodity"];
            } else {
              errorHeaderNames.push("Commodity");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Qualified Indicator" in eachRow) {
              _tempObj.qualified = eachRow["Qualified Indicator"];
            } else {
              errorHeaderNames.push("Qualified Indicator");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Service Level" in eachRow) {
              _tempObj.serviceLevel = eachRow["Service Level"];
            } else {
              errorHeaderNames.push("Service Level");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Primary Owner" in eachRow) {
              _tempObj.primaryOwner = eachRow["Primary Owner"];
            } else {
              errorHeaderNames.push("Primary Owner");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if (eachRow["Secondary Owner"]) {
              _tempObj.secondaryOwner = eachRow["Secondary Owner"];
            } else {
              // Not mandatory filed
              _tempObj.secondaryOwner = null;
            }
            if ("Allocation Indicator" in eachRow) {
              _tempObj.allocatIndicator = eachRow["Allocation Indicator"];
            } else {
              errorHeaderNames.push("Allocation Indicator");
              _tempObj.Reason = `Header name error ${errorHeaderNames}`;
              excelHeadersValid = false;
            }
            if ("Remarks" in eachRow) {
              _tempObj.remarks = eachRow["Remarks"];
            } else {
              // Not mandatory filed
              _tempObj.remarks = null;
            }
            newOJSArray.push(_tempObj);
          });
          oJS = newOJSArray;

          var objpreQualAdd = {};

          var arrpreQualbulk = [];
          var objpreQualbulk = {};

          var brecordInserted = false;
          var newfromDate = new Date();
          var newtoDate = "99991231";
          // newfromDate = $filter("date")(newfromDate, "yyyyMMdd");
          newfromDate = "20210727";

          if (excelHeadersValid) {
            for (var i = oJS.length - 1; i >= 0; i--) {
              var bDuplicate = false;
              var bValid = false;
              oJS[i].edit = true;
              oJS[i].recordType = "N";
              oJS[i].validFrom = newfromDate;
              oJS[i].validTo = newtoDate;

              oJS[i].carrier = getValueFromText(
                ddData["carrier"],
                oJS[i].scacd
              );

              //Check origin and destination values valid / not

              let originDestinationValidation = checkOriginDestination(oJS[i]);

              if (!originDestinationValidation.status) {
                oJS[i].Reason = originDestinationValidation.Reason;
                duplicateRecordDisplay.current = [
                  ...duplicateRecordDisplay.current,
                  oJS[i],
                ];
              } else {
                //Check other values valid / not
                if (checkValue(ddData["serviceType"], oJS[i].servType)) {
                  if (checkValue(ddData["mode"], oJS[i].modeOfTransport)) {
                    if (
                      checkValue(ddData["serviceLevel"], oJS[i].serviceLevel)
                    ) {
                      if (
                        checkText(ddData["primaryOwner"], oJS[i].primaryOwner)
                      ) {
                        if (
                          checkText(
                            ddData["secondaryOwner"],
                            oJS[i].secondaryOwner
                          ) ||
                          oJS[i].secondaryOwner == null
                        ) {
                          if (checkText(ddData["carrier"], oJS[i].scacd)) {
                            console.log("carrier");
                            if (
                              oJS[i].qualified === "Y" ||
                              oJS[i].qualified === "N" ||
                              oJS[i].qualified === "y" ||
                              oJS[i].qualified === "n"
                            ) {
                              console.log("qualified");
                              if (
                                oJS[i].allocatIndicator === "Y" ||
                                oJS[i].allocatIndicator === "N" ||
                                oJS[i].allocatIndicator === "y" ||
                                oJS[i].allocatIndicator === "n"
                              ) {
                                // allocatIndicator should be 'N' when qualified is 'N'
                                if (
                                  oJS[i].qualified === "N" ||
                                  oJS[i].qualified === "N"
                                )
                                  oJS[i].allocatIndicator = "N";

                                bValid = true;
                              } else {
                                oJS[i].Reason =
                                  "Data is Incorrect please check Allocation Indicator";
                              }
                            } else {
                              oJS[i].Reason =
                                "Data is Incorrect please check Qualified Indicator";
                            }
                          } else {
                            oJS[i].Reason =
                              "Data is Incorrect please check SCAC";
                          }
                        } else {
                          oJS[i].Reason =
                            "Data is Incorrect please check Secondary Owner";
                        }
                      } else {
                        oJS[i].Reason =
                          "Data is Incorrect please check Primary Owner";
                      }
                    } else {
                      oJS[i].Reason =
                        "Data is Incorrect please check Service Level";
                    }
                  } else {
                    oJS[i].Reason = "Data is Incorrect please check Mode";
                  }
                } else {
                  oJS[i].Reason = "Data is Incorrect please check Commodity";
                }
                if (!bValid) {
                  duplicateRecordDisplay.current = [
                    ...duplicateRecordDisplay.current,
                    oJS[i],
                  ];
                }
              }
              //End of Check

              //Start after Valid
              if (bValid) {
                brecordInserted = true;
                //Record storing for Bulk Upload
                objpreQualAdd = buildAddPreQualArray(
                  oJS[i],
                  userData["USER_ID"]
                );
                arrpreQualbulk.push(objpreQualAdd);
              }
            }
          

          objpreQualbulk["action"] = "SUBM";

          objpreQualbulk["dataList"] = arrpreQualbulk;

          let BulkUploadresponse = await addQualificationRecord(objpreQualbulk);

          BulkUploadresponse = JSON.stringify(BulkUploadresponse);
          BulkUploadresponse = JSON.parse(BulkUploadresponse);

          if (BulkUploadresponse.length) {
            BulkUploadresponse.map((record) => {
              record.Reason = record.msg;

              duplicateRecordDisplay.current = [
                ...duplicateRecordDisplay.current,
                record,
              ];
            });
          }
        
          onSearchClick(lastSearchState);

          setDataState({ skip: 0, take: 10 });

          setOJS(oJS);
          setDuplicateVisiable(true);

          if (oJS.length == duplicateRecordDisplay.current.length) {
            toast.error(
              "Upload : Upload failed for all Records, please check the below grid for failed values"
            );
          } else if (!duplicateRecordDisplay.current.length) {
            toast.success("Upload : All Records updated successfully");
          } else {
            toast.error(
              "Upload : Partial suceess  : Upload failed for some of the records , please check the below grid for failed values"
            );
          }

          setDuplicateVisiable(true);
        } else{
          toast.error(`Invalid template format/ ${errorHeaderNames} missing/Incorrect`);
        }
        } else {
          toast.error("No Records found in excel file");
        }
      });
    };

    // Tell JS To Start Reading The File.. You could delay this if desired
    //reader.readAsBinaryString(oFile);
    //IE Issue with Upload
    reader.readAsArrayBuffer(oFile);
    //Try this for uploading the same File issue
    oEvent.target.value = null;
  };

  let checkOriginDestination = (valueObj) => {
    const originResult = ddData["originDestinationTrimData"].find(
      ({ port }) => port == valueObj.originValue
    );
    if (
      originResult &&
      originResult.geo == valueObj.originGeo &&
      originResult.country == valueObj.originCountry
    ) {
      const destinationResult = ddData["originDestinationTrimData"].find(
        ({ port }) => port == valueObj.destinationValue
        );
        if (
          destinationResult &&
          destinationResult.geo == valueObj.destinationGeo &&
          destinationResult.country == valueObj.destCountry
          ) {
      } else {
        return {status: false, Reason: "Data is Incorrect please check destination values"};
      }
    } else {
      return {status: false, Reason: "Data is Incorrect please check origin values"};
    }
    return {status: true};
  };

  return (
    <>
      <div className="tableStyle">
        {tableData.length !== 0 && (
          <ExcelExport
            fileName={fileName}
            ref={(exporter) => (_export = exporter)}
          >
            <Grid
              style={{ height: "600px", width: 'auto',fontSize: 12}}
              data={result}
              pageable
              {...dataState}
              total={result.length}
              filterable
              onDataStateChange={onDataStateChange}
              reorderable
              selectedField="selected"
              onSelectionChange={selectionChange}
              onHeaderSelectionChange={headerSelectionChange}
              ScrollMode="scrollable"
            >
              <GridToolbar>
                <div>
                    <>
                      <input
                        id="fileid"
                        type="file"
                        onChange={updloadExcel}
                        hidden
                      />
                      <input
                        className="btn k-button k-button-icontext ml-2 btn-qualification"
                        id="buttonid"
                        type="button"
                        value="Upload File"
                      />
                      <button
                        className="btn k-button k-button-icontext ml-2 btn-qualification"
                        onClick={addRecord}
                      >
                        Add new record
                      </button>
                    </>
                  <button
                    className="btn k-button k-button-icontext ml-2 btn-qualification"
                    title="Export Excel"
                    onClick={exportExcel}
                  >
                    Export to Excel
                  </button>
                    <button
                      className="btn k-button k-button-icontext rejectbtn ml-2 btn-qualification"
                      onClick={toggleDialog}
                    >
                      Delete
                    </button>
                </div>
              </GridToolbar>
              <Column
                field="selected"
                width="40px"
                filterable={false}
                headerSelectionValue={
                  result.data.findIndex(
                    (dataItem) => dataItem.selected === false
                  ) === -1
                }
              />
              <Column
                width="69px"
                cell={MyEditCommandCell}
                headerCell={() => <span style={{fontSize: 12,fontWeight: "bold"}}>Update</span>}
                filterable={false}
              />
              <Column
                width="93px"
                field="scacd"
                title="SCAC"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    SCAC <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                width="70px"
                field="modeOfTransport"
                title="Mode"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Mode <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                field="originValue"
                title="Origin Port"
                width="88px"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Origin Port <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                field="originCountry"
                title="Origin Country / Region"
                width="87px"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Origin Country / Region <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                field="originGeo"
                title="Origin Geo"
                width="75px"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Origin Geo <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                width="95px"
                field="destinationValue"
                title="Destination Port"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Destination Port <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                width="95px"
                field="destCountry"
                title="Destination Country / Region"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Destination Country / Region <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                width="95px"
                field="destinationGeo"
                title="Destination Geo"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Destination Geo <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                width="95px"
                field="servType"
                title="Commodity"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Commodity <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                field="qualified"
                title="Qualified Indicator"
                width="95px"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Qualified Indicator <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                field="serviceLevel"
                title="Service Level"
                width="76px"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Service Level <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                field="primaryOwner"
                title="Primary Owner"
                width="88px"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Primary Owner <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                field="secondaryOwner"
                title="Secondary Owner"
                width="88px"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Secondary Owner <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column
                field="allocatIndicator"
                title="Allocation Indicator"
                width="95px"
                headerCell={() => (
                  <span style={{fontSize: 12,fontWeight: "bold"}}>
                    Allocation Indicator <em className="emColor">*</em>
                  </span>
                )}
              />
              <Column field="remarks" title="Remarks" width="110px" headerCell={() => <span style={{fontSize: 12,fontWeight: "bold"}}>Remarks</span>} />
              <Column
                width="95px"
                field="createdOn"
                title="Last Changed Date"
                headerCell={() => <span style={{fontSize: 12,fontWeight: "bold"}}>Last Changed Date</span>}
              />
              <Column
                width="110px"
                field="createdBy"
                title="Last Changed By"
                headerCell={() => <span style={{fontSize: 12,fontWeight: "bold"}}>Last Changed By</span>}
              />
            </Grid>
          </ExcelExport>
        )}
        {openForm && (
          <QualificationForm
            cancelEdit={handleCancelEdit}
            onSubmit={handleSubmit}
            editItem={editItem}
            ddData={{ qualified: ["Y", "N"],allocatIndicator: ["Y","N"], ...ddData }}
          />
        )}
        {visibleDialog && (
          <Dialog title={"Confirm Carrier Delete"} onClose={toggleDialog}>
            <p style={{ margin: "25px", textAlign: "center" }}>
              Are you sure you want to delete?
            </p>
            <DialogActionsBar>
              <button className="k-button" onClick={deleteRow}>
                DELETE
              </button>
              <button className="k-button k-gray" onClick={toggleDialog}>
                CANCEL
              </button>
            </DialogActionsBar>
          </Dialog>
        )}
        {/* <ToastContainer position="top-right" autoClose={5000} /> */}
        {/* <div>
          <pre>{JSON.stringify(tableData, null, 2)}</pre>
        </div> */}
      </div>

      {duplicateVisiable && (
        <ExcelErrorRecords duplicateRecord={duplicateRecordDisplay.current} />
      )}
    </>
  );
}

const EditCommandCell = (props) => {
  const { ROLE_LIST } = JSON.parse(sessionStorage.getItem("profile"));
  const { MDADMIN, MDVIEWER } = ROLE_LIST;

  return (
    <td>
       <span 
        className="k-icon k-i-pencil"
        style={{cursor: "pointer"}}
        onClick={() => props.enterEdit(props.dataItem)}
      >
      </span>
    </td>
  );
};

export default QualificationTable;
